import axios from 'axios'
import qs from 'qs'

class Http {
  constructor() {
    this.http = axios.create({
      baseURL: window.location.protocol + '//survey.58.com',
      timeout: 30321,
      headers: {
        post: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        }
      }
    })
  }

  get = (url, params = {}) => {
    return this.http({
      method: 'get',
      params: params,
      url: url
    })
  }
  post = (url, data = {}) => {
    return this.http({
      method: 'post',
      data: qs.stringify(data),
      url: url
    })
  }
}
const instance = new Http()

export default instance



// WEBPACK FOOTER //
// ./src/utils/upload.js